import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Valida uno o varios emails separados por coma o punto y coma.
 * Vacío = válido (usar Validators.required aparte si aplica).
 */
export function commaSeparatedEmailsValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const raw = control.value;
		if (typeof raw !== 'string' || raw.trim() === '') {
			return null;
		}
		const emails = raw
			.split(/[,;]/)
			.map((email: string) => email.trim())
			.filter((email: string) => email.length > 0);
		if (emails.length === 0) {
			return null;
		}
		return emails.every((email) => EMAIL_PATTERN.test(email)) ? null : { email: true };
	};
}

/**
 * Validadores para campos email_alert de aviso de fraude (required + formato).
 */
export function fraudEmailAlertValidators(enabled: boolean): ValidatorFn[] | null {
	return enabled ? [Validators.required, commaSeparatedEmailsValidator()] : null;
}
